import { render, staticRenderFns } from "./notification-footer-for-unregistered.vue?vue&type=template&id=d8c3b5f2&scoped=true"
import script from "./notification-footer-for-unregistered.vue?vue&type=script&lang=js"
export * from "./notification-footer-for-unregistered.vue?vue&type=script&lang=js"
import style0 from "./notification-footer-for-unregistered.vue?vue&type=style&index=0&id=d8c3b5f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8c3b5f2",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BaseButton: require('/home/ploi/www.orderchamp.dev-deploy/www.orderchamp.dev/28072026_171207/resources/assets/marketplace/components/BaseButton.vue').default})
